<template>
  <div>
    <!-- loading -->
    <v-dialog v-model="loading" persistent fullscreen style="z-index: 999">
      <v-container fill-height>
        <v-layout row justify-center align-center style="z-index: 100">
          <v-progress-circular
            indeterminate
            :size="70"
            :width="7"
            color="teal"
          ></v-progress-circular>
        </v-layout>
      </v-container>
      <div id="loading-background"></div>
    </v-dialog>
    <!-- content -->
    <v-container>
      <div class="content-area">
        <v-row style="border-bottom: 1px solid rgb(216, 216, 216)">
          <v-col cols="auto" style="font-size: 30px" v-if="!crud"
            >Questions</v-col
          >
          <v-col
            cols="auto"
            style="font-size: 30px"
            v-if="crud && action == 'create'"
            >Add New Questions</v-col
          >
          <v-col
            cols="auto"
            style="font-size: 30px"
            v-if="crud && action == 'update'"
            >Update Questions</v-col
          >
          <v-col style="width: 100%; padding: 0px 20px 0px 20px">
            <v-text-field
              v-model="search"
              label="search"
              append-icon="mdi-magnify"
              single-line
              hide-details
              v-if="!crud"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
            <v-btn
              color="success"
              block
              style="float: right"
              v-if="!crud"
              @click="Actions('create')"
            >
              <v-icon style="margin: 0px 5px 0px -5px">mdi-plus</v-icon>Create
            </v-btn>
            <v-btn
              color="primary"
              block
              style="float: right"
              v-if="crud"
              @click="Back"
            >
              <v-icon style="margin: 0px 5px 0px -5px">mdi-arrow-left</v-icon
              >Back
            </v-btn>
          </v-col>
        </v-row>
        <div v-if="!crud">
          <!-- data table -->
          <div v-if="listItems.length == 0">
            <p style="font-size: 20px; text-align: center; margin: 40px">
              {{ message }}
            </p>
          </div>
          <!-- :single-select="singleSelect" show-select -->
          <v-data-table
            :headers="headers"
            :items="listItems"
            :search="search"
            item-key="ID"
            class="elevation-1"
            style="margin-top: 30px"
            v-if="listItems.length > 0"
          >
            <template v-slot:item.QuestionSetID="{ item }">
              <v-row>
                <v-col style="max-width: 550px">{{
                  QuestionSet(item.QuestionSetID)
                }}</v-col>
              </v-row>
            </template>
            <template v-slot:item.action="{ item }">
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon>mdi-cogs</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="Actions('update', item)">
                    <v-list-item-title>Update</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="Delete(item.ID)">
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </div>
        <div v-if="crud">
          <Question :QuestionData="updateItem" @update-data="Back" />
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import Question from "./CRUDComponent/Question";
import axios from "axios";
import { IP, AuthKey } from "../../../config";

export default {
  data() {
    return {
      search: "",
      message: "No question yet.",
      headers: [
        // { text: "ID", value: "ID" },
        { text: "Question Set", value: "QuestionSetID" },
        { text: "Question Title", value: "QuestionTitle" },
        { text: "Question Type", value: "QuestionType" },
        { text: "Actions", value: "action", sortable: false },
      ],
      listItems: [],
      questionSetItems: [],
      crud: false,
      action: "",
      loading: false,
      updateItem: null,
    };
  },
  components: {
    Question,
  },
  methods: {
    Back() {
      this.crud = false;
      this.Start();
    },
    QuestionSet(id) {
      for (var i = 0; i < this.questionSetItems.length; i++) {
        if (this.questionSetItems[i].ID == id) {
          return this.questionSetItems[i].QuestionSetName;
        }
      }
    },
    Actions(action, item) {
      if (action == "create") {
        this.updateItem = null;
        this.action = action;
        this.crud = true;
      } else if (action == "update") {
        this.updateItem = item;
        this.action = action;
        this.crud = true;
      }
    },
    Delete(id) {
      return new Promise(async (resolve, reject) => {
        this.$swal
          .fire({
            title: "Are you sure ?",
            text: `Do you want to delete this question ?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
          })
          .then(async (result) => {
            if (result.value) {
              this.loading = true;
              console.log("delete: ", id);
              axios({
                method: "DELETE",
                url: `${IP}/question/delete/${id}`,
                headers: {
                  Authorization: AuthKey,
                },
              }).then((response) => {
                this.Start();
                this.loading = false;
                this.$swal.fire("Delete question success !", "", "success");
              });
            }
          });
      });
    },
    GetAllQuestion() {
      return new Promise(async (resolve, reject) => {
        axios
          .get(`${IP}/question/get-all`, {
            headers: {
              Authorization: AuthKey,
            },
          })
          .then(async (response) => {
            console.log("listItems: ", response.data);
            let result = response.data;
            for (var i = 0; i < result.length; i++) {
              // result[i].QuestionChoices = await atob(result[i].QuestionChoices)
              // result[i].QuestionTitle = await atob(result[i].QuestionTitle);
              // result[i].QuestionDescription = await atob(
              //   result[i].QuestionDescription
              // );

              result[i].QuestionChoices = await this.b64DecodeUnicode(
                result[i].QuestionChoices
              );
              result[i].QuestionTitle = await this.b64DecodeUnicode(
                result[i].QuestionTitle
              );
              result[i].QuestionDescription = await this.b64DecodeUnicode(
                result[i].QuestionDescription
              );
            }
            this.listItems = response.data;
            resolve(true);
          });
      });
    },
    b64DecodeUnicode(str) {
      if (str != null) {
        str = str.replace(/\s/g, "");
        return decodeURIComponent(escape(window.atob(str)));
      }
    },
    GetAllQuestionSet() {
      return new Promise(async (resolve, reject) => {
        axios
          .get(`${IP}/question-set/get-all`, {
            headers: {
              Authorization: AuthKey,
            },
          })
          .then((response) => {
            console.log("questionSetItems: ", response.data);
            this.questionSetItems = response.data;
            resolve(true);
          });
      });
    },
    async Start() {
      this.user = this.$store.getters.currentUser;
      this.message = "Loading...";
      await this.GetAllQuestionSet().then((response) => {
        this.GetAllQuestion().then(() => {
          this.message = "No question yet.";
        });
      });
    },
  },
  created() {
    this.Start();
  },
};
</script>

<style lang="scss" scoped>
.content-area {
  width: 95%;
  margin: 0 auto;
}
</style>